var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var edit = require('../layout/components/edit');
var modal = require('../layout/components/modal');
var modalForm = require('../layout/components/modalForm');
var heading = require('../components/heading');
var button = require('../components/button');
var Model = require('../libs/Model');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var rowActionDropdown = require('../components/rowActionDropdown');
var formatCalibrationDue = require('./formatCalibrationDue');

var certifiedInstrument = Object.assign(require('../../../../models/assets/certifiedInstrument'), Model);
modalForm(certifiedInstrument);

var component = {};

function hasRecords(record, fieldName) {
  return record && Array.isArray(record[fieldName]) && record[fieldName].length > 0;
}

function canDeleteCertifiedInstrument(record) {
  return !hasRecords(record, 'in_Certifies') && !hasRecords(record, 'out_usedFor');
}

component.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('CertifiedInstruments');
  document.title = 'nimrod | Certified Instruments';
  ctrl.newNode = prop(false);

  ctrl.init = function (){
    loaders.requestWithLoader({
      url: "/api/v1/certifiedinstrument/",
      method: "GET",
    })
    .then(function(result){
      ctrl.certifiedInstruments = result;
      ctrl.newNode(true);
    });
  }

  ctrl.certifiedInstrumentsToShow = [];


  ctrl.init();
}

component.view = function () {
  var ctrl = this
  if (!ctrl.certifiedInstruments) {
    return m('div')
  }
  return m('div.mh3', [
    m(heading,{label:'Certified Instruments', class:'f-subheadline mb3 pb1 display'},[
      edit.vm.editing() ? m(rowActionDropdown, {
        items: [
          {
            label: 'Add Certified Instrument',
            icon: 'ion-plus',
            onclick: function () {
              m.route.set('/certifiedinstrument/new');
            }
          }
        ]
      }) : ''
    ]),
    m(paginationWithSearch, {
      data: ctrl.certifiedInstruments,
      newNode: ctrl.newNode,
      dataToShow: ctrl.certifiedInstrumentsToShow,
      placeHolder: 'Search',
      itemsPerPage: 30,
      fieldsToSearch: ['name', 'model', 'serialNumber'],
    },[
      m('table.w-100.f4.mb5.pt3', [
        m('thead', [
          m('tr', [
            m('th.ph0.tl', 'Name'),
            m('th.ph0.tl', 'Model'),
            m('th.ph0.tl', 'Serial'),
            m('th.ph0.tl', 'Valid Until'),
            m('th.ph0.tl.ph2', 'Actions')
          ])
        ]),
        m('tbody', [
          ctrl.certifiedInstrumentsToShow.map(function (record) {
            if (!record['@rid']) {
              return m('tr', [
                m('td.tl.pv0.nowrap',[
                  m('label',{style:{'visibility':'hidden'}}, 'No Data')
                ]),
                m('td.tl.pv0.nowrap'),
                m('td.tl.pv0.nowrap'),
                m('td.tl.pv0.nowrap'),
                m('td.tl.pv0.nowrap', [
                  m('div', { style: { visibility: 'hidden' } }, [
                    m(rowActionDropdown, { items: [] })
                  ])
                ])
              ]);
            } else {
              return m('tr', [
                m('td.tl', record.name),
                m('td.tl', record.model),
                m('td.tl', record.serialNumber),
                m('td.tl', formatCalibrationDue(record.calibrationDue)),
                m('td', [
                  m(rowActionDropdown, {
                    items: [
                      {
                        label: 'Edit',
                        icon: 'ion-ios-compose',
                        onclick: function () {
                          m.route.set('/certifiedinstrument/' + record['@rid'].slice(1));
                        }
                      }
                    ].concat(canDeleteCertifiedInstrument(record) ? [
                      {
                        label: 'Delete',
                        icon: 'ion-ios-trash',
                        class: 'red',
                        onclick: certifiedInstrument.deleteDialogue.bind(certifiedInstrument, record, {dashboardCallback: ctrl.init})
                      }
                    ] : [])
                  })
                ])
              ]);
            }
          })
        ])
      ])
    ])
  ])
 }

module.exports = component;
